<template>
  <div class="user-block">
    <el-dropdown v-if="isLogin" :teleported="false">
      <img class="avatar" @click="goToLink('account-info')"
        :src="userStore.profile.avatar || require('@/assets/images/common/default_avatar.png')" />
      <template #dropdown>
        <div class="msg-block">
          <img class="msg-avatar"
            :src="userStore.profile.avatar || require('@/assets/images/common/default_avatar.png')" />
          <div class="msg-detail">
            <p class="name">
              {{ userStore.profile.nickName || userStore.profile.userName }}
            </p>
            <p class="id">
              <span class="label">ID</span>
              <span class="value">{{ userStore.profile.id }}</span>
            </p>
          </div>
        </div>
        <div class="balance-block">
          <div class="balance-up">
            <span class="title">{{ $t('pecenter.myBalance') }}</span>
            <span class="link" @click="goToLink('asset')">{{ $t('pecenter.topUp') }}</span>
          </div>
          <div class="balance-down">
            {{ userStore.currency }} {{ userStore.currencyUnit
            }}{{
              typeof state.balance.balance !== 'number'
                ? '--'
                : $flatRateOrigin(state.balance.balance, userStore.rate)
            }}
          </div>
        </div>
        <el-dropdown-menu class="dropdown-menu">
          <el-dropdown-item @click="goToLink('order-list')">{{
            $t('pecenter.myOrder')
          }}</el-dropdown-item>
          <el-dropdown-item @click="goToLink('storage')">{{
            $t('pecenter.storage.name')
          }}</el-dropdown-item>
          <el-dropdown-item @click="goToLink('my-package')">{{
            $t('pecenter.package.myPackage')
          }}</el-dropdown-item>
          <el-dropdown-item @click="goDistribution">{{
            $t('pecenter.myAffiliate.name')
          }}</el-dropdown-item>
          <el-button @click="logout" class="logout-btn">{{ $t('form.logout') }}</el-button>
        </el-dropdown-menu>
        <div></div>
      </template>
    </el-dropdown>
    <div v-else class="btn-list">
      <div class="btn" @click="goToLogin">{{ $t('form.login') }}</div>
    </div>
  </div>
</template>

<script setup>
import { getUserBalance } from '@/apis/user'
import { useDistributionStore, useUserStore } from '@/stores'
import { computed, reactive } from 'vue'
import { useRoute, useRouter } from 'vue-router'

const $router = useRouter()
const $route = useRoute()
const userStore = useUserStore()
const distributionStore = useDistributionStore()
const isLogin = computed(() => !!userStore.token)
const distributionUserInfo = computed(() => distributionStore.userInfo)

const state = reactive({
  balance: {},
})
const logout = () => {
  userStore.logout()
  distributionStore.logout()
  localStorage.removeItem('isStorageAccept')
  $router.push('/')
}

const goToLogin = () => {
  $router.push({ path: '/login', query: { redirectUrl: `${$route.fullPath}` } })
}

const goToLink = (name) => {
  $router.push({ name })
}
const getUserBalanceData = async () => {
  if (!userStore.isLogin) return
  const res = await getUserBalance()
  state.balance = res
}
// 前往二级分销
const goDistribution = async () => {
  try {
    if (distributionUserInfo.value.hasAgreeAgreement) {
      $router.push({ name: 'distribution' })
    } else {
      await distributionStore.getDistributionUserInfo()
      distributionUserInfo.value.hasAgreeAgreement
        ? $router.push({ name: 'distribution' })
        : $router.push({ name: 'my-affiliate' })
    }
  } catch (error) {
    $router.push({ name: 'my-affiliate' })
  }
}
getUserBalanceData()
</script>

<style lang="scss" scoped>
.user-block {
  padding-left: 16px;

  .avatar {
    width: 32px;
    height: 32px;
    display: block;
    border-radius: 50%;
    cursor: pointer;
  }

  ::v-deep {
    .el-dropdown {
      &:focus-visible {
        border: none;
        box-shadow: none;
      }
    }
  }

  .btn-list {
    .btn {
      background-color: var(--primary-color);
      text-align: center;
      color: var(--white-color-1-light);
      cursor: pointer;
      min-width: 72px;
      height: 36px;
      border-radius: 918px;
      line-height: 36px;
      font-size: 14px;
      padding-left: 4px;
      padding-right: 4px;
      font-weight: bold;
      font-family: Montserrat;

      &:hover {
        background: #209874;
      }
    }
  }
}

.link {
  padding-left: 8px;
  color: var(--primary-color);
}

.msg-block {
  width: 252px;
  margin: 24px 24px 8px 24px;
  display: flex;
  align-items: center;

  .msg-avatar {
    width: 44px;
    height: 44px;
    border-radius: 50%;
    display: block;
  }

  .msg-detail {
    flex: 1;
    margin-left: 10px;

    .name {
      font-size: 14px;
      font-weight: 600;
      color: var(--black-common-color-9);
    }

    .id {
      margin-top: 6px;

      .label {
        width: 17px;
        padding: 0 4px;
        background: #31b38c;
        border-radius: 387px;
        color: var(--white-color-1-light);
        text-align: center;
      }

      .value {
        margin-left: 4px;
        font-size: 12px;
        color: var(--black-color-1-dark);
      }
    }
  }
}

.balance-block {
  width: 252px;
  margin: auto;
  padding: 12px 10px;
  background-color: rgba(236, 250, 246, 1);
  border-radius: 4px;

  .balance-up {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .title {
      font-size: 12px;
      color: #31b38c;
    }

    .link {
      display: block;
      padding: 4px 10px;
      border-radius: 16px;
      color: #31b38c;
      background-color: var(--white-color-1-light);
      border: 1px solid #dadee6;
      cursor: pointer;
      font-size: 14px;
      font-weight: 600;
    }
  }

  .balance-down {
    margin-top: 10px;
    color: #31b38c;
    font-size: 16px;
    font-weight: 600;
  }
}

.dropdown-menu {
  width: 252px;
  margin: auto;

  .dropdown-item {
    padding-left: 0;
    color: var(--black-common-color-9);
  }
}

.logout-btn {
  width: 252px;
  margin: auto;
  margin-top: 8px;
  margin-bottom: 30px;
}

:deep(.el-dropdown-menu__item) {
  color: var(--black-common-color-9);
}
</style>
